import { find } from 'lodash'
import {
  PS_PROGRESS,
  PS_REPORTING_FORMAT_OPTIONS,
  PS_TYPES,
} from '../../consts'

export const getPartnerSearchTypeName = (searchType: string) => {
  return (
    find(PS_TYPES, (patentSearchType) => patentSearchType.value === searchType)
      ?.label ?? 'Unknown'
  )
}

export const getPartnerSearchProgressName = (progress: number) => {
  if (progress === 1) {
    return 'Submitted'
  }
  return find(PS_PROGRESS, (p) => p.value === progress)?.label ?? 'Completed'
}

export const getPartnerSearchReportingFormatLabel = (
  reportingFormat: string
) => {
  return (
    find(PS_REPORTING_FORMAT_OPTIONS, (patentReportingFormat) => {
      return patentReportingFormat.value === reportingFormat
    })?.label ?? null
  )
}

export const getPartnerSearchProgressbarVariant = (progress: number) => {
  switch (progress) {
    case 2: {
      return 'warning'
    }

    case 4:
    case 5: {
      return 'danger'
    }

    case 6: {
      return 'success'
    }

    default: {
      return 'secondary'
    }
  }
}
